// Polymorphic functions without a specific type
import { complement } from './function';
import { isObject } from './type';

// Applies to arrays, strings, and nulls
export const isEmpty = (s: unknown | null | undefined): boolean =>
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-nested-ternary
  s
    ? typeof s === 'string' ||
      Array.isArray(s) ||
      // @ts-expect-error ts-migrate(2361) FIXME: The right-hand side of an 'in' expression must not... Remove this comment to see the full error message
      (isObject(s) && 'length' in s)
      ? s.length === 0
      : (() => {
          throw new Error('got unexpected value in isEmpty');
        })()
    : true;
// Applies to arrays, strings, and nulls
export const isNotEmpty: (arg0: unknown | null | undefined) => boolean =
  complement(isEmpty);
